import React from 'react';
import styled from 'styled-components';
import { Svg } from './ui';
import badge from '../images/badge.svg';

const StyledBadge = styled(Svg)``;

const Badge = ({ ...props }) => <StyledBadge image={badge} {...props} />;

export default Badge;
